import {gettext} from 'utils/text';

export default function toggleDescription(selector) {
    const productDescription = document.querySelector(selector);
    const productDescriptionContainer = document.getElementById('descriptionBaseHeight');

    if (!productDescription || !productDescriptionContainer) {
        return;
    }

    const productDescActionsHeight = 122; // sum of the height of .product-stock & margin of .product-attributes
    const baseHeightElement = document.querySelector('.product-gallery').offsetHeight - productDescActionsHeight;
    const productDescriptionContainerHeight = productDescriptionContainer.offsetHeight;

    const btnContainer = document.getElementById('productMoreContainer');

    // use string concatenation instead of template string to fix django's makemessages of js files
    /* eslint-disable */
    const btnMarkup =
        '<div class="row product-info__read--more">' +
        '    <div class="col-xs-12">' +
        '        <a href="#" id="expandDescriptionBtn">' + gettext('Read more') + '</a>' +
        '    </div>' +
        '</div>';
    /* eslint-enable */

    if (productDescriptionContainerHeight > baseHeightElement) {
        btnContainer.innerHTML = btnMarkup;
        productDescription.classList.add('fade-overflow-desc');
    } else {
        return;
    }

    const expandDescriptionBtn = document.getElementById('expandDescriptionBtn');

    const toggleHiddenClasses = () => {
        productDescription.classList.toggle('show-desc');
        productDescription.classList.toggle('fade-overflow-desc');

        if (!productDescription.classList.contains('show-desc')) {
            expandDescriptionBtn.innerText = gettext('Read more');
        } else {
            expandDescriptionBtn.innerText = gettext('Read less');
        }
    };


    const toggleDescriptionExpansion = (event) => {
        event.preventDefault();
        toggleHiddenClasses();
    };

    expandDescriptionBtn.addEventListener('click', toggleDescriptionExpansion);
}



// WEBPACK FOOTER //
// ./src/widgets/ToggleDescription.js